import {Box} from '@constellation/core';
import {styled} from 'styled-components';

export const Div = styled(Box)`
  background-color: #fff !important;
`;

export const FieldWrapper = styled.div<{
  extendMargin: number;
  extendedWidth?: number;
}>`
  .csl-field {
    margin-bottom: ${(props) => `${props.extendMargin}px`};
    width: ${(props) => `${props.extendedWidth}%` || '100%'};
  }
`;

export const FieldWrapperHideOptionalText = styled.div<{
  extendMargin: number;
  extendedWidth?: number;
}>`
  .csl-field {
    margin-bottom: ${(props) => `${props.extendMargin}px`};
    width: ${(props) => `${props.extendedWidth}%` || '100%'};
  }
  .csl-field-label > .csl-text-s2:nth-child(2) {
    display: none;
  }
`;

export const StyledRow = styled.div`
  margin-top: 1.5rem;
`;

export const BoxFormWrapper = styled(Box)`
  ${(props) => `
  padding: 0px !important;
  @media (min-width: ${props.theme.breakpoint_lg}) {
    padding-right: 30% !important;
  }
`}
`;

export const IconBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f1f1f1;
`;
